import React from 'react';
import { FixedSizeList } from 'react-window';

import PopUp from 'components/_parts/atoms/popUp/popUp';
import Label from 'components/_parts/atoms/label';

function Window({
  data,
  handleTarget,
  width,
  height,
  dataType,
  layoutPopUp,
  props,
}) {
  const dynamicHeight = height;
  const dynamicWidth = width - 40;

  function RowData({ index, style }) {
    const item = data[index];
    let newData = '';
    switch (dataType) {
      case 'structure':
        newData = item.name;
        break;
      case 'employee':
        newData = item.nama;
        break;
      case 'wlaAnalytics':
        newData = item.region_name;
        break;
      case 'version':
        newData = item.label;
        break;

      default:
        break;
    }

    return (
      <div
        onClick={() => (data?.[0]?.id === 1 ? '' : handleTarget(item))}
        className={`windowItem ${data?.[0]?.id === 1 ? 'pointerOff' : ''}`}
        style={style}
      >
        <Label className="mb-0 windowText">{newData || index}</Label>
        {/* <p className="mb-0 windowText">Data {index}</p> */}
      </div>
    );
  }

  return (
    <PopUp
      isHide={!(data === undefined || data?.length === 0)}
      style={{ width: 'auto', height: 'auto', overflow: 'hidden' }}
      layout={{
        height: 'auto',
        maxHeight: 'none',
        overflow: 'hidden',
        ...layoutPopUp,
      }}
    >
      <FixedSizeList
        height={dynamicHeight}
        width={dynamicWidth}
        itemCount={data?.length || 0}
        // itemCount={1000}
        itemSize={35}
        className="scroll_custom_window"
      >
        {RowData}
      </FixedSizeList>
    </PopUp>
  );
}

export default Window;
